
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/customerio",
      function () {
        return require("private-next-pages/destinations/customerio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/customerio"])
      });
    }
  